import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { put } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function StatusChange({ userData, fetchUser, setShowStatusChange }: any) {
  const { id } = useParams()
  const { notify } = useGlobalContext()
  const [cancelLoading, setCancelLoading] = useState(false)
  const [role, setRole] = useState(userData.status)

  async function changeRole() {
    const data = {
      status: role,
    }
    if (role.length < 4) {
      notify('warn', 'Pick a role')
      return
    }
    setCancelLoading(true)
    put(`admin/change-admin-status/${id}`, data)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Admin Status Updated')
          setShowStatusChange(false)
          fetchUser()
        } else {
          notify('error', result.message)
        }
        setCancelLoading(false)
      })
      .catch(() => {
        setCancelLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Change Admin Status Role</h1>
        <p>Note: this will change the admin status and their access</p>
        <select
          name=''
          id=''
          value={role}
          onChange={(e) => setRole(e.target.value)}
        >
          <option value=''>-select-</option>
          <option value='active'>Active</option>
          <option value='inactive'>Inactive</option>
        </select>
        {cancelLoading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowStatusChange(false)}>Cancel</button>
            <button className='proceed' onClick={changeRole}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default StatusChange
